export const GET_FABRIC_RESOURCE = "GET_FABRIC_RESOURCE"
export const GET_FABRIC_RESOURCE_SUCCESS = "GET_FABRIC_RESOURCE_SUCCESS"
export const GET_FABRIC_RESOURCE_ERROR = "GET_FABRIC_RESOURCE_ERROR"
